import { Button, Col, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { MdDeleteForever } from "react-icons/md";
import { IoChevronBackCircleSharp } from "react-icons/io5";
import { useAuthContext } from "../../hooks/useAuthContext";
import { useFirestore } from "../../hooks/useFirestore";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useCollection } from "../../hooks/useCollection";

import "./GalleryDetails.css";

export default function GalleryDetails() {
	const location = useLocation();
	const Piece = location.state;
	const { user } = useAuthContext();
	const navigate = useNavigate();
	const { deleteDocument, deleteImg } = useFirestore("projects");
	const [active, setActive] = useState(false);
	const { documents } = useCollection("users");

	useEffect(() => {
		if (user) {
			documents.forEach((u) => {
				if (u.id === user.uid) {
					setActive(u);
				}
			});
		}
	}, [documents, user]);

	const delePiece = () => {
		deleteDocument(Piece.id);
		deleteImg(Piece);
		navigate("/gallery");
	};
	const ADMIN = process.env.REACT_APP_ADMIN_USER;

	return (
		<div className='body-app-content'>
			<div className='galleryDetailsBack'>
				<Button onClick={() => navigate("/gallery")}>
					<IoChevronBackCircleSharp
						style={{ fontSize: "1.5em", padding: "2px" }}
					/>
					back
				</Button>
			</div>
			<Row className='GalletyDetails-content'>
				<Col md={8}>
					<img
						className='GalletyDetails-img'
						src={Piece.photoURL}
						alt={Piece.name}
					/>
				</Col>
				<Col md={4}>
					<div
						onClick={delePiece}
						className='cursor-pointer w-14 flex flex-col justify- text-end '
					>
						{/* <span className='text-xs lg:text-lg me-3  '>Delete</span> */}
						{active && active.admin === true && (
							<Button onClick={delePiece} className='btn btn-primary'>
								<MdDeleteForever color='red' size='2rem' />
							</Button>
						)}
					</div>
					<h4>{Piece.name}</h4>
					<p>{Piece.year}</p>
					<hr />
					<p>{Piece.details}</p>
					{user && user.uid === ADMIN && (
						<MdDeleteForever className='detailsIcon' onClick={delePiece} />
					)}
					<hr />
					{Piece.sold && <p style={{ color: "#520227" }}>sold.</p>}
				</Col>
			</Row>
		</div>
	);
}
